module.exports = __webpack_public_path__ + "static/media/facebook.63cecf29.svg";